module.exports = __webpack_public_path__ + "img/chat-icon.295ce3b2.svg";